import { InjectionToken } from '@angular/core';

export const APP_FORM_FIELD_PROVIDER: InjectionToken<{showErrors: boolean}> = new InjectionToken<{showErrors: boolean}>('window');
